/* Filtrous accessibility shim (2026-08-18) — loaded from layout/theme.liquid.
   Repairs markup the theme does not own or that is rendered client-side:
   1. Boost-rendered product cards (template lives in Boost admin, JS served from cdn.boostcommerce.io):
      <a class="fn-card__image-wrap"> has an image only -> WCAG 2.4.4 / 4.1.2 link-name. Copy the card title.
   2. Boost mobile filter drawer: dialog semantics, initial focus, Tab trap, Escape, focus restore.
   3. Target size (WCAG 2.5.8 AA): four control groups render under 24x24 (2026-08-28 audit).
   Idempotent, cheap (one rAF per DOM mutation batch). Remove once the Boost product-item template carries
   aria-label="{{ product.title }}" itself. */
(function () {
  'use strict';
  if (window.__fltA11y) return; window.__fltA11y = 1;
  var pending = false;

  function nameBoostCards() {
    var links = document.querySelectorAll('.boost-sd__product-item a.fn-card__image-wrap:not([aria-label]):not([aria-hidden])');
    for (var i = 0; i < links.length; i++) {
      var a = links[i], card = a.closest('.boost-sd__product-item'), t = '';
      var h = card && card.querySelector('.fn-card__title');
      if (h) t = h.textContent;
      if (!t) { var img = a.querySelector('img'); t = img ? (img.getAttribute('alt') || '') : ''; }
      t = (t || '').replace(/\s+/g, ' ').trim();
      if (t) { a.setAttribute('aria-label', t); }
      else { a.setAttribute('aria-hidden', 'true'); a.setAttribute('tabindex', '-1'); }
    }
  }

  /* 2. Boost mobile filter drawer ("Refine By"): no dialog role, focus not moved in, no Tab trap,
        Escape does not close, focus lost on close (WCAG 2.4.3 / 2.1.2 / 4.1.2). Boost toggles
        body.boost-sd__g-no-scroll while the drawer is open. */
  var drawerOpen = false, opener = null, drawerEl = null;
  var FOCUSABLE = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function visible(el) { var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden'; }
  function drawerFocusables() { return Array.prototype.filter.call(drawerEl.querySelectorAll(FOCUSABLE), visible); }
  function onKey(e) {
    if (!drawerOpen || !drawerEl) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      var close = drawerEl.querySelector('.boost-sd__button--close');
      if (close) { e.preventDefault(); close.click(); }
      return;
    }
    if (e.key !== 'Tab') return;
    var f = drawerFocusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (!drawerEl.contains(a)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }
  function syncDrawer() {
    var el = document.querySelector('.boost-sd__filter-tree-vertical-sticky-overlay .boost-sd__filter-tree-vertical--sticky');
    var isOpen = !!el && document.body.classList.contains('boost-sd__g-no-scroll') && visible(el);
    if (isOpen && !drawerOpen) {
      drawerOpen = true; drawerEl = el;
      opener = document.activeElement && document.activeElement !== document.body ? document.activeElement : document.getElementById('boost-sd__filter-tree-toggle-button');
      el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true');
      if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', 'Filter products');
      document.addEventListener('keydown', onKey, true);
      var tries = 0;
      (function focusIn() {
        if (!drawerOpen || tries++ > 20) return;
        if (!drawerEl.contains(document.activeElement)) {
          var f = drawerFocusables(), target = null;
          for (var i = 0; i < f.length; i++) if (f[i].classList.contains('boost-sd__button--close')) { target = f[i]; break; }
          target = target || f[0];
          if (target) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }
        }
        setTimeout(focusIn, 120); /* Boost re-focuses its toggle shortly after opening; keep nudging for ~2.5s */
      })();
    } else if (!isOpen && drawerOpen) {
      drawerOpen = false; document.removeEventListener('keydown', onKey, true);
      if (el) { el.removeAttribute('aria-modal'); }
      var back = opener || document.getElementById('boost-sd__filter-tree-toggle-button');
      if (back && document.contains(back)) { try { back.focus(); } catch (e) {} }
      opener = null; drawerEl = null;
    }
  }

  /* 3. TARGET SIZE — WCAG 2.5.8 Target Size (Minimum), AA: 24x24 CSS px.
        Audit 2026-08-28 (theme 1.13, desktop 1280 and mobile 375) found four groups under it:
          .fv3-cart              57x22  — header cart button, 1px block padding
          .fv3-crumb a           ~20px  — breadcrumb row, no block padding, line-height 19.5
          .ff3-footer .ff-col a  ~20px  — footer nav columns, line-height 20.3
          .signin                17x17  — header account link (mobile header)
        All four are stacked or laid out in a row with spare vertical room, so block padding grows
        the hit box without moving anything around it. Padding rather than min-height because these
        are display:block/flex children whose height is driven by line-height.

        DELIBERATELY NOT TOUCHED: p.ff-tag a ("Net-30 for labs", 18px). It sits inside a sentence,
        which is the Inline exception in 2.5.8 — inflating it would overlap the lines above and below
        for no conformance gain.

        Injected here rather than in a stylesheet because this asset already loads on every template
        from layout/theme.liquid; adding a CSS file would mean editing a section loader for one rule
        block. Revert: delete this function and its call in run(). */
  function targetSize() {
    if (document.getElementById('flt-a11y-target-size')) return;
    if (!document.head) return;
    var css = document.createElement('style');
    css.id = 'flt-a11y-target-size';
    css.textContent =
      '.fv3-headrow .fv3-cart{min-height:24px;}' +
      'a.signin{min-width:24px;min-height:24px;display:inline-flex;align-items:center;justify-content:center;}' +
      '#fv3-app .fv3-crumb a{padding-top:3px;padding-bottom:3px;}' +
      '.ff3-footer .ff-col a{padding-top:3px;padding-bottom:3px;}';
    document.head.appendChild(css);
  }

  function run() { pending = false; try { nameBoostCards(); } catch (e) {} try { syncDrawer(); } catch (e) {} try { targetSize(); } catch (e) {} }
  function schedule() { if (!pending) { pending = true; (window.requestAnimationFrame || window.setTimeout)(run); } }
  function start() {
    targetSize(); /* once, up front - it does not depend on any mutation */
    schedule();
    try { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }); } catch (e) {}
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
